<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'HubExpertRessourcesConstruireSupportDeFormation'
});
</script>
<template>
  <ka-container
    code="expert-ressource-4-support-de-formation"
    :data="page.$info.expertRessource4SupportDeFormation">
    <!-- Container page -->
    <ka-container code="container-page">
      <RessourcesEntete
        instance-class="ressources-entete--p46"
        title="<strong>Comment rédiger un support de formation ?</strong>" />
      <!-- Container -->
      <ka-container code="container">
        <ka-text code="quest-ce-que-le-support">
          <h2 v-html="t('expertRessource4SupportDeFormation.containerPage.container.questCeQueLeSupport.value', `Qu’est ce que le support de formation ?`)" />
        </ka-text>
        <ka-text code="le-support-de-formation">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.leSupportDeFormation.value', `<span style='background-color:transparent;color:#000000;'>Le support de formation est un document qui répertorie les notions abordées au cours des échanges. Il n’a pas pour vocation de reprendre l’entièreté de la formation et d’être un déroulé théorique pédagogique. Il intervient comme appui autant à l’expert qu’aux stagiaires pour structurer l’accompagnement et laisser une trace des sujet. </span>`)" />
        </ka-text>
        <ka-text code="le-temps-que-vous">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.leTempsQueVous.value', `<strong>Le temps que vous y passerez sera du temps CA-PI-TA-LI-SÉ. Bien préparer votre première formation vous permettra d’en réutiliser le contenu pour les prochaines !</strong>`)" />
        </ka-text>
        <ka-text code="k-5-objectifs">
          <h2 v-html="t('expertRessource4SupportDeFormation.containerPage.container.k5Objectifs.value', `Les 5 objectifs du support de formation 👌`)" />
        </ka-text>
        <!-- objectifs - déroulant -->
        <ka-container code="objectifs-deroulant">
          <!-- Conteneur question -->
          <ka-container code="conteneur-question">
            <!-- Deroulent -->
            <ka-container
              code="deroulent"
              :options="{
                click: page.deroulentClick,
                $state: { selected: $isEqual(page.$elements['question-1']?.style.hidden, page.$constants.question1Hidden) }
              }"
              :selected="{ click: page.deroulentClickWhenSelected }">
              <!-- placement -->
              <ka-container code="placement">
                <ka-text code="k-1-amener-le-formateur">
                  <h3 v-html="t('expertRessource4SupportDeFormation.containerPage.container.objectifsDeroulant.conteneurQuestion.deroulent.placement.k1AmenerLeFormateur.value', `1. Amener le formateur à structurer son accompagnement`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icone-developper-4"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 1 -->
            <ka-container
              code="question-1"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="effectivement-le">
                <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.objectifsDeroulant.conteneurQuestion.question1.effectivementLe.value', `<span style='background-color:transparent;color:#000000;'>Effectivement, le support permet de préparer la formation en détails. Il permet ainsi de renforcer la confiance de l’expert lors des sessions et de se projeter.</span>`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-1">
            <!-- Deroulent -->
            <ka-container
              code="container-2"
              :options="{
                click: page.container2Click,
                $state: { selected: $isEqual(page.$elements['question-2']?.style.hidden, page.$constants.question2Hidden) }
              }"
              :selected="{ click: page.container2ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-3">
                <ka-text code="k-2-renforcer-lautonomie">
                  <h3 v-html="t('expertRessource4SupportDeFormation.containerPage.container.objectifsDeroulant.container1.container2.container3.k2RenforcerLautonomie.value', `2. Renforcer l’autonomie des apprenants `)" />
                  <template #xs>
                    <h3 v-html="t('expertRessource4SupportDeFormation.containerPage.container.objectifsDeroulant.container1.container2.container3.k2RenforcerLautonomie.xs.value', `2. Renforcer l’autonomie des apprenants`)" />
                  </template>
                </ka-text>
              </ka-container>
              <ka-icon
                code="icone-developper-1"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 2 -->
            <ka-container
              code="question-2"
              :options="{ hidden: null }">
              <ka-text code="les-sessions-ont-pour">
                <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.objectifsDeroulant.container1.question2.lesSessionsOntPour.value', `<span style='background-color:transparent;color:#000000;'>Les sessions ont pour objectifs de :</span><br> <p><ol><li><span style='background-color:transparent;color:#000000;'>   transmettre des informations. </span></li><li><span style='background-color:transparent;color:#000000;'>   mettre des choses en place ensemble. </span></li></ol><p> <br><span style='background-color:transparent;color:#000000;'>Fournir un support de formation permet donc aux apprenants de se décharger d’une prise de notes permanente. La relation doit davantage se rapprocher d’une relation collaborative que d’une relation professeur/élève. </span><br> <br><span style='background-color:transparent;color:#000000;'>Le support permet également aux apprenants de relire les slides entre les sessions et ainsi s'appuyer sur le contenu pour réitérer les mises en situation.</span></p>`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-4">
            <!-- Deroulent -->
            <ka-container
              code="container-5"
              :options="{
                click: page.container5Click,
                $state: { selected: $isEqual(page.$elements['question-3']?.style.hidden, page.$constants.question3Hidden) }
              }"
              :selected="{ click: page.container5ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-6">
                <ka-text code="k-3-donner-de-la-visibilite">
                  <h3 v-html="t('expertRessource4SupportDeFormation.containerPage.container.objectifsDeroulant.container4.container5.container6.k3DonnerDeLaVisibilite.value', `3. Donner de la visibilité à Matchers sur les sujets traités `)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icone-developper-3"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 3 -->
            <ka-container
              code="question-3"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="a-laide-de-ce-support">
                <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.objectifsDeroulant.container4.question3.aLaideDeCeSupport.value', `À l’aide de ce support, Matchers peut suivre l’évolution de la formation. En fin de formation notre service qualité passe en revue le support afin de s’assurer de sa cohérence avec la formation cloturée. <br> <br><strong>⚠️  Matchers se réserve le droit de ne pas clôturer une formation si l’expert ne fournit pas de support de formation valide.</strong>`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-7">
            <!-- Deroulent -->
            <ka-container
              code="container-8"
              :options="{
                click: page.container8Click,
                $state: { selected: $isEqual(page.$elements['question-4']?.style.hidden, page.$constants.question4Hidden) }
              }"
              :selected="{ click: page.container8ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-9">
                <ka-text code="k-4-evaluer-laisance">
                  <h3 v-html="t('expertRessource4SupportDeFormation.containerPage.container.objectifsDeroulant.container7.container8.container9.k4EvaluerLaisance.value', `4. Évaluer l’aisance de l’expert à transmettre`)" />
                  <template #xs>
                    <h3 v-html="t('expertRessource4SupportDeFormation.containerPage.container.objectifsDeroulant.container7.container8.container9.k4EvaluerLaisance.xs.value', `<strong>4. Évaluer l’aisance de l’expert à transmettre</strong>`)" />
                  </template>
                </ka-text>
              </ka-container>
              <ka-icon
                code="icone-developper-2"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 4 -->
            <ka-container
              code="question-4"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="la-qualite-du-support">
                <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.objectifsDeroulant.container7.question4.laQualiteDuSupport.value', `La qualité du support de formation est également un élément d’appui pour évaluer l’aptitude de l’expert à clarifier ses connaissances, les organiser, les développer et les transmettre.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
          <!-- Conteneur question -->
          <ka-container code="container-10">
            <!-- Deroulent -->
            <ka-container
              code="container-11"
              :options="{
                click: page.container11Click,
                $state: { selected: $isEqual(page.$elements['question-5']?.style.hidden, page.$constants.question5Hidden) }
              }"
              :selected="{ click: page.container11ClickWhenSelected }">
              <!-- placement -->
              <ka-container code="container-12">
                <ka-text code="k-5-conserver-cet-outil">
                  <h3 v-html="t('expertRessource4SupportDeFormation.containerPage.container.objectifsDeroulant.container10.container11.container12.k5ConserverCetOutil.value', `5. Conserver cet outil pour les apprenants après la formation`)" />
                </ka-text>
              </ka-container>
              <ka-icon
                code="icon-1"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
            <!-- Question 5 -->
            <ka-container
              code="question-5"
              :options="{
                animationIn: `fadeIn`,
                hidden: null
              }">
              <ka-text code="a-lissue-de-la-formation">
                <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.objectifsDeroulant.container10.question5.aLissueDeLaFormation.value', `À l’issue de la formation les participants doivent être en mesure de re-produire les notions mises en application avec l’expert. Rien ne s’apprend en une fois. <br> <br>Il faut y revenir, reproduire, répéter et répéter pour que cela soit parfaitement maîtrisé. Livrer un support qui reprend le contenu de vos échanges et de vos mises en pratique<strong> permettra aux apprenants de prolonger leur montée en compétences</strong>.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
        <ka-text code="k-7-conseils">
          <h2 v-html="t('expertRessource4SupportDeFormation.containerPage.container.k7Conseils.value', `<strong>Nos 7 conseils pour établir votre support de formation</strong>`)" />
        </ka-text>
        <ka-image
          code="image"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Grâce à Matchers, vous avez toutes les cartes en main pour établir un support de formation structuré avec de bonnes ressources `
          }"
          value="https://ucarecdn.com/5cec9b7c-6259-4814-a859-17012d1a6087/" />
        <ka-text code="sous-titre">
          <h2 v-html="t('expertRessource4SupportDeFormation.containerPage.container.sousTitre.value', `1. Établir un sommaire en se basant sur le programme de formation`)" />
        </ka-text>
        <ka-text code="une-formation-peut">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.uneFormationPeut.value', `<span style='background-color:transparent;color:#000000;'>Une formation peut être divisée en différents modules si elle regroupe <strong>plusieurs thématiques</strong>. Ce cas de figure nécessite souvent l’intervention de plusieurs experts.  Ces différents modules sont eux-mêmes divisés en parties qui détaillent chaque point à aborder. </span><br> <br><span style='background-color:transparent;color:#000000;'>La formation peut également être focalisée sur une seule thématique et dans ce cas le programme ne comprend qu’un module divisé en plusieurs parties.</span>`)" />
        </ka-text>
        <ka-text code="text-1">
          <h2 v-html="t('expertRessource4SupportDeFormation.containerPage.container.text1.value', `2. Le construire au fur et à mesure de la formation`)" />
        </ka-text>
        <ka-text code="vous-demarrez-une-formation">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.vousDemarrezUneFormation.value', `Vous démarrez une formation qui va s’étendre sur plusieurs semaines. Il se peut que les besoins de l'entreprise évoluent ou/et que les apprenants montent en compétence rapidement. <strong>Si vous préparez votre formation trop en amont votre support pourrait bien devenir obsolète. </strong>Créer le support en plusieurs phases vous permettra de personnaliser le contenu selon la progression et les enjeux de l’entreprise.`)" />
        </ka-text>
        <ka-text code="exemple-pour">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.exemplePour.value', `<p style='margin-left:40px;'><strong>Exemple : </strong></p><p style='margin-left:40px;'> </p><p style='margin-left:40px;'><i>Pour une formation de 30h :</i></p><ul><li style='margin-left:40px;'><i>Phase 1 : Je crée le sommaire et le contenu pour les 10 premières heures.  </i></li><li style='margin-left:40px;'><i>Phase 2 : Je modifie le sommaire si nécessaire et je crée le contenu des 20 prochaines heures.</i></li></ul>`)" />
        </ka-text>
        <ka-text code="text-2">
          <h2 v-html="t('expertRessource4SupportDeFormation.containerPage.container.text2.value', `3. La taille : trouver le juste milieu`)" />
        </ka-text>
        <ka-text code="le-support-doit-etre">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.leSupportDoitEtre.value', `Le support doit être un véritable outil. C’est davantage la qualité de son contenu qui est essentielle et non sa longueur. Néanmoins, voici un référentiel de ce qui est considéré comme correct. `)" />
        </ka-text>
        <ka-text code="voici-un-referentiel">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.voiciUnReferentiel.value', `Voici un référentiel :<br> <p><ul><li><strong>De 6h à 12h</strong> : 8 - 10 slides</li><li><strong>De 12h à 20h </strong>: 15 - 25 slides</li><li><strong>Plus de 20h</strong> : 25 - 35 slides</li><li><strong>Plus de 40h</strong> :<strong> </strong>35 - 45 slides</li><li><strong>Plus de 60h </strong>: 45 - 60 slides</li></ul><p> <br> <br><span style='background-color:transparent;color:#000000;'>⚠️<strong> Attention à ne pas faire :</strong></span><br> <br><span style='background-color:transparent;color:#000000;'><strong>Trop long :</strong> 1) Faire pour faire ne fera pas de ce support un outil utile 2) Il s’agit d’une formation opérationnelle, les experts plus consciencieux pourraient passer des heures à construire le support, ce n’est pas le but. L’objectif est de faire de l'opérationnel. </span><br> <br><span style='background-color:transparent;color:#000000;'><strong>Trop court : </strong>Matchers peut revenir vers l’expert pour signaler la non validité du support de formation fourni. L’étude de Matchers est faite de bonne foi. L'équipe vérifie la pertinence du contenu avec la formation à différentes étapes de l'accompagnement. </span></p>`)" />
        </ka-text>
        <ka-text code="text-3">
          <h2 v-html="t('expertRessource4SupportDeFormation.containerPage.container.text3.value', `4. Présenter les concepts théoriques, le vocabulaire et l’environnement`)" />
        </ka-text>
        <ka-image
          code="image-1"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Transmettez vos expertises, ses aspects et son vocabulaire avec un support de formation complet`
          }"
          value="https://ucarecdn.com/67c77b99-0268-4e34-8865-532a5b5d75ec/" />
        <ka-text code="bien-que-les-formations">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.bienQueLesFormations.value', `Bien que les formations Matchers soient avant tout des formation pratiques qui encouragent la mise en application immédiate, une partie théorique est toujours nécessaire dans la transmission.`)" />
        </ka-text>
        <ka-text code="exemple-marketing">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.exempleMarketing.value', `<p><strong>Exemple : </strong></p><p> </p><p>Marketing digital - Concept théorique </p><p>Intitulé présent dans le programme : Maîtriser la matrice AARRR </p><p style='margin-left:120px;'> </p><ul><li><span style='color:hsl(0,0%,60%);'>Slide 1 | Acquisition - Générer du trafic sur son site</span></li><li><span style='color:hsl(0,0%,60%);'>Slide 2 | Activation - Convertir ses visiteurs</span></li><li><span style='color:hsl(0,0%,60%);'>Slide 3 | Rétention - Fidéliser ses clients</span></li><li><span style='color:hsl(0,0%,60%);'>Slide 4 | Revenue - Optimiser son ROI</span></li><li><span style='color:hsl(0,0%,60%);'>Slide 5 | Referral - Créer des prescripteurs</span></li></ul>`)" />
        </ka-text>
        <ka-text code="text-4">
          <h2 v-html="t('expertRessource4SupportDeFormation.containerPage.container.text4.value', `5. Puiser et présenter les références que vous connaissez`)" />
        </ka-text>
        <ka-text code="il-ne-sagit-pas-de">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.ilNeSagitPasDe.value', `Il ne s’agit pas de réinventer la roue. Si vous suivez un blog ou une newsletter qui vous semble pertinent, vous pouvez tout à fait vous en inspirer et ajouter des extraits dans votre support de formation. <br> <br><strong>Partager toutes les ressources qui vous semblent utiles peut également faire partie du support de formation. </strong>Une slide avec les influenceurs à suivre, les podcasts à écouter et les vidéos à visionner est un vrai coup de pouce pour les apprenants ! N’oubliez pas de citer vos sources. 😉`)" />
        </ka-text>
        <ka-image
          code="image-2"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Bâtissez un programme de formation clair et complet grâce à vos connaissances, mais aussi aux ressources que vous trouvez pertinentes`
          }"
          value="https://ucarecdn.com/54d9450f-59e7-4d48-a950-6e6937b093f3/" />
        <ka-text code="text-5">
          <h2 v-html="t('expertRessource4SupportDeFormation.containerPage.container.text5.value', `6. Considérer 20% de théorie 80% de pratique`)" />
        </ka-text>
        <ka-text code="chaque-session-doit">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.chaqueSessionDoit.value', `<p>Chaque session doit permettre à l’entreprise, par des mises en pratique, d’avancer sur leur(s) projet(s).<strong> Les 80% de pratique sont à considérer</strong> lors de la création du support de formation pour deux raisons : </p><p> </p><ul><li>Cela va prendre du temps au cours des échanges, de ce fait ne vous sentez pas obligé de meubler et étayer les concepts théoriques si ce n’est pas utile. L’objectif étant d’acquérir la compétence pour la mettre en pratique et non en maîtriser toutes les savants recoins.</li></ul><p> </p><ul><li>Il faut également intégrer ces mises en pratique dans le support de formation. Pour cela, vous pouvez vous appuyer sur le point suivant.</li></ul>`)" />
        </ka-text>
        <ka-text code="text-6">
          <h2 v-html="t('expertRessource4SupportDeFormation.containerPage.container.text6.value', `<strong>7. Créer des “Mémo” pour les cas pratiques</strong>`)" />
        </ka-text>
        <ka-text code="apres-chaque-session">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.apresChaqueSession.value', `Après chaque session, les apprenants doivent être autonomes. Pour cela, n’hésitez pas à alimenter le support de captures d’écran qui retracent les étapes d’une manip que vous avez pu faire au cours de la session. Ils pourraient ainsi répéter l’opération d'ici la session prochaine.`)" />
        </ka-text>
        <ka-text code="exemple">
          <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.exemple.value', `<p style='margin-left:40px;'><span style='color:hsl(0,0%,60%);'><strong>Exemple : </strong></span></p><p style='margin-left:40px;'> </p><ul><li><span style='background-color:transparent;color:hsl(0,0%,60%);'>Suite de captures d'écran qui présente toutes les étapes pour mettre en ligne une campagne facebook Ads.</span></li><li><span style='background-color:transparent;color:hsl(0,0%,60%);'>Étapes détaillées sur un outil spécifique, de toutes les manipulations à effectuer pour envoyer une séquence de mails automatisée.</span></li></ul>`)" />
        </ka-text>
        <ka-text code="bonnes-et-mauvaises-pratiques">
          <h2 v-html="t('expertRessource4SupportDeFormation.containerPage.container.bonnesEtMauvaisesPratiques.value', `<strong>Les bonnes et mauvaises pratiques</strong>`)" />
        </ka-text>
        <!-- Container exemples -->
        <ka-container code="container-exemples">
          <!-- Container -->
          <ka-container code="container-13">
            <!-- Container -->
            <ka-container code="container-14">
              <ka-text code="✅">
                <h1 v-html="t('expertRessource4SupportDeFormation.containerPage.container.containerExemples.container13.container14.✅.value', `<span style='background-color:transparent;color:#000000;'><strong>✅</strong></span>`)" />
              </ka-text>
            </ka-container>
            <ka-text code="reprendre-les-etapes">
              <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.containerExemples.container13.reprendreLesEtapes.value', `<ul><li>Reprendre les étapes du programme de formation. </li></ul><p> </p><ul><li>Construire des mémo en intégrant des captures d’écrans des cas pratique / applications concrètes. </li></ul><p> </p><ul><li>Puiser dans des ressources dont vous disposez.</li></ul>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-15">
            <!-- Container -->
            <ka-container code="container-16">
              <ka-text code="❌">
                <h1 v-html="t('expertRessource4SupportDeFormation.containerPage.container.containerExemples.container15.container16.❌.value', `<span style='background-color:transparent;color:#000000;'><strong>❌</strong></span>`)" />
              </ka-text>
            </ka-container>
            <ka-text code="construire-un-support">
              <span v-html="t('expertRessource4SupportDeFormation.containerPage.container.containerExemples.container15.construireUnSupport.value', `<ul><li>Construire un support de formation trop volumineux.</li></ul><p> </p><ul><li>Construire un support de formation trop mince.</li></ul><p> </p><ul><li>Ne pas avoir établi de sommaire avant le démarrage de la formation. </li></ul><p> </p><ul><li>Y passer trop de temps.</li></ul>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
      </ka-container>
      <!-- Container -->
      <ka-container code="container-17">
        <!-- Container -->
        <ka-container
          code="container-18"
          :xs="{ hidden: null }">
          <ka-text code="titre">
            <span v-html="t('expertRessource4SupportDeFormation.containerPage.container17.container18.titre.value', `Sommaire :`)" />
          </ka-text>
          <ka-text
            code="text-7"
            :options="{
              href: { hash: `#quest-ce-que-le-support--p46` },
              ariaLabel: `text`,
              click: page.text7Click
            }">
            <span v-html="t('expertRessource4SupportDeFormation.containerPage.container17.container18.text7.value', `<ul><li><strong>Qu’est ce que le support de formation ?</strong></li></ul>`)" />
          </ka-text>
          <!-- Container -->
          <ka-container code="container-19">
            <ka-text
              code="text-8"
              :options="{
                href: { hash: `#k-5-objectifs--p46` },
                ariaLabel: `text`,
                click: page.text8Click
              }">
              <span v-html="t('expertRessource4SupportDeFormation.containerPage.container17.container18.container19.text8.value', `<ul><li><strong>Les 5 objectifs du support de formation</strong></li></ul>`)" />
            </ka-text>
            <ka-icon
              code="icone-dev-down"
              :options="{
                click: page.iconeDevDownClick,
                $state: { selected: $isEqual(page.$elements['k-5-objectifs-txt']?.style.hidden, page.$constants.k5ObjectifsTxtHidden) }
              }"
              :selected="{ click: page.iconeDevDownClickWhenSelected }"
              value="i-fa-solid:angle-down" />
            <ka-text
              code="k-5-objectifs-txt"
              :options="{ hidden: null }">
              <span v-html="t('expertRessource4SupportDeFormation.containerPage.container17.container18.container19.k5ObjectifsTxt.value', `<span style='color:hsl(0,0%,60%);'>1 - Amener l'expert à structurer son accompagnement.</span><br><span style='color:hsl(0,0%,60%);'>2 - Renforcer l'autonomie des apprenants.</span><br><span style='color:hsl(0,0%,60%);'>3 - Donner la visibilité à Matchers sur les sujets traités.</span><br><span style='color:hsl(0,0%,60%);'>4 - Évaluer l'aisance de l'expert à transmettre. </span><br><span style='color:hsl(0,0%,60%);'>5 - Conserver cet outil pour les apprenants après la formation.  </span>`)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-20">
            <ka-text
              code="text-9"
              :options="{
                href: { hash: `#k-7-conseils--p46` },
                ariaLabel: `text`,
                click: page.text9Click
              }">
              <span v-html="t('expertRessource4SupportDeFormation.containerPage.container17.container18.container20.text9.value', `<ul><li><strong>Nos 7 conseils pour le construire</strong></li></ul>`)" />
            </ka-text>
            <ka-icon
              code="icon-2"
              :options="{
                click: page.icon2Click,
                $state: { selected: $isEqual(page.$elements['k-7-conseils-txt']?.style.hidden, page.$constants.k7ConseilsTxtHidden) }
              }"
              :selected="{ click: page.icon2ClickWhenSelected }"
              value="i-fa-solid:angle-down" />
            <ka-text
              code="k-7-conseils-txt"
              :options="{ hidden: null }">
              <span v-html="t('expertRessource4SupportDeFormation.containerPage.container17.container18.container20.k7ConseilsTxt.value', page.$constants.k7ConseilsTxt)" />
            </ka-text>
          </ka-container>
          <!-- Container -->
          <ka-container code="container-21">
            <ka-text
              code="text-10"
              :options="{
                href: { hash: `#bonnes-et-mauvaises-pratiques--p46` },
                ariaLabel: `text`,
                click: page.text10Click
              }">
              <span v-html="t('expertRessource4SupportDeFormation.containerPage.container17.container18.container21.text10.value', `<ul><li><strong>Les bonnes et mauvaises pratiques</strong></li></ul>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <!-- Container 2 -->
        <ka-container code="container-22">
          <ka-text code="text-11">
            <span v-html="t('expertRessource4SupportDeFormation.containerPage.container17.container22.text11.value', `Autres ressources disponibles :`)" />
          </ka-text>
          <BlocPreviewRessourceSansDescription
            instance-class="preview-ressource-short--p46"
            :options="{
              href: { name: `Expert-Ressources-organiser-sa-formation` },
              click: page.previewRessourceShortClick
            }"
            title="<strong>Comment bien organiser sa formation ?</strong>"
            image="https://images.unsplash.com/photo-1616530834117-9167fb0d8ebc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwxOXx8Y2FsZW5kYXJ8ZW58MHx8fHwxNjkyODAwMTMzfDA&ixlib=rb-4.0.3&q=80&w=1080" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-1--p46"
            :options="{
              href: { name: `Expert-Ressources-animer-la-formation` },
              click: page.element1Click
            }"
            title="<strong>Animer la formation</strong>"
            image="https://images.unsplash.com/photo-1612831455359-970e23a1e4e9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHw5fHxwciVDMyVBOXNlbnRhdGlvbnxlbnwwfHx8fDE2OTIyNjA3OTJ8MA&ixlib=rb-4.0.3&q=80&w=1080" />
          <BlocPreviewRessourceSansDescription
            instance-class="element-2--p46"
            :options="{
              href: { name: `Expert-Ressources-Evaluations` },
              click: page.element2Click
            }"
            title="<strong>Évaluer les apprentissages</strong>"
            image="https://images.unsplash.com/photo-1518349619113-03114f06ac3a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwzMHx8dGVzdHxlbnwwfHx8fDE2OTIyODY5NjR8MA&ixlib=rb-4.0.3&q=80&w=1080" />
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { hubExpertRessourcesConstruireSupportDeFormation } from './store'
import BlocPreviewRessourceSansDescription from '~/components/BlocPreviewRessourceSansDescription/index.vue'
import RessourcesEntete from '~/components/RessourcesEntete/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p46')
const appData = appDataStore()
const page = hubExpertRessourcesConstruireSupportDeFormation()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
